package org.hs_soft.runmynesto.pages.home.sub_page.dashboard.mvi

import org.hs_soft.runmynesto.domain.model.home.dashboard.customer_frequency.GetCustomerFrequency
import org.hs_soft.runmynesto.domain.model.home.dashboard.dashboard_config.ListShopItem
import org.hs_soft.runmynesto.domain.model.home.dashboard.get_shop_statics.ShopStatistic
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.YearModel
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.getYearsData
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

data class DashboardState(
    val calendarData: YearModel = getYearsData(
        startYear = Constants.startYear,
        endYear = Constants.endYear
    ),
    val errorInfo:String?=null,
    val dataLoadingProgressVisible:Boolean=false,
    val selectedDate:MonthModel= MonthModel(),
    val clientCompareDate:MonthModel=MonthModel(),
    val saleCompareDate:MonthModel=MonthModel(),
    val showCalendarDialog:Boolean=false,
    val showCompareSaleChartDialog:Boolean=false,
    val listShop: List<ListShopItem?>?= null,
    val requestId:String?=null,
    val shopStaticsData: List<ShopStatistic>? =null,
    val showCompareClientChartDialog:Boolean=false,
    val selectedCompanyProfile:String?=null,
    val showDashboardDetail:Boolean=false,
    val customerFrequencies:List<GetCustomerFrequency?>?=null,
    val comparedClientsCustomerFrequencies: List<Double?>? =null,
    val comparedSalesCustomerFrequencies: List<Double?>? =null,
    val selectedShop:ListShopItem?=ListShopItem(
        name = LanguageManager.getCurrentStrings().allTheRegions,
    ),
    val timeType:String?=null,
    val currencyType:String?=null,
    val selectedDashboardItem:ShopStatistic?=null,
    val dashboardItemName:String?=null,
)